import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getData } from "@/services/axios";

import { ref } from 'vue';
export default {
  __name: 'ForumAttachmentArticle',
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props; // @ts-check

    var isGetS3UrlRunning = ref(false);

    var getS3SignedUrl = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var newWindow, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isGetS3UrlRunning.value) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                isGetS3UrlRunning.value = true; //secure browserのpopup block 対策

                newWindow = window.open();
                _context.prev = 4;
                _context.next = 7;
                return getData("reader/get_s3_signed_url?path=" + encodeURIComponent(props.attachment.object_key));

              case 7:
                data = _context.sent;
                newWindow.location = data.items.s3url;
                isGetS3UrlRunning.value = false;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                console.log(_context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12]]);
      }));

      return function getS3SignedUrl() {
        return _ref.apply(this, arguments);
      };
    }();

    return {
      __sfc: true,
      props: props,
      isGetS3UrlRunning: isGetS3UrlRunning,
      getS3SignedUrl: getS3SignedUrl
    };
  }
};